import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ClientBasicInfoForm } from '../../client_configuration';
import type { ClientFormData } from '../utilities/formDataUtils';
import type { ValidationError } from '@/utils/validation/types';

interface BasicsStepProps {
  formData: ClientFormData;
  onUpdate: (field: keyof ClientFormData, value: ClientFormData[keyof ClientFormData]) => void;
  onFieldBlur: (field: keyof ClientFormData) => void;
  isLoading: boolean;
  errors: ValidationError[];
  touchedFields: Set<string>;
  isAiGenerated: boolean;
  setIsAiGenerated: (value: boolean) => void;
}

const BasicsStepComponent: React.FC<BasicsStepProps> = ({
  formData,
  onUpdate,
  onFieldBlur,
  isLoading,
  errors,
  touchedFields,
  isAiGenerated,
  setIsAiGenerated,
}) => {
  return (
    <Card>
      <CardContent className="p-6 space-y-6">
        <ClientBasicInfoForm
          formData={formData}
          onUpdate={onUpdate}
          onFieldBlur={onFieldBlur}
          isLoading={isLoading}
          errors={errors}
          touchedFields={touchedFields}
          isAiGenerated={isAiGenerated}
          setIsAiGenerated={setIsAiGenerated}
        />
      </CardContent>
    </Card>
  );
};

export const BasicsStep = React.memo(BasicsStepComponent);
